import { render } from "./CandidatesTable.vue?vue&type=template&id=33507843"
import script from "./CandidatesTable.vue?vue&type=script&lang=js"
export * from "./CandidatesTable.vue?vue&type=script&lang=js"

import "./CandidatesTable.vue?vue&type=style&index=0&id=33507843&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__